module.exports = require("prismjs/components/prism-scala.js");